// Adresse d'un autre domaine redirigée vers une adresse de la messagerie, d'où Robin peut écrire
// (src/aliases.ts).
export interface SendingAlias { alias: string; address: string; name: string }

// Ce qu'il faut d'un e-mail (Message, dans api.ts) : le module reste testable hors navigateur.
interface Mail {
  address: string;
  location: string;
  from: { address: string };
  to: { address: string }[];
  cc: { address: string }[];
}

// Expéditeur d'une réponse choisi d'avance : l'adresse d'un autre domaine à laquelle l'e-mail a
// été écrit, ou depuis laquelle il a été envoyé, pour que le correspondant voie la même adresse.
export function replyAlias(message: Mail, aliases: SendingAlias[]): string | undefined {
  const known = (address: string) => aliases.some((a) => a.alias === address && a.address === message.address);
  if (message.location === "sent") return known(message.from.address) ? message.from.address : undefined;
  return [...message.to, ...message.cc].map((m) => m.address).find(known);
}
